var exports = {
  "Nr": "StreamWatchHoverCard.module__card___QjNaNU",
  "Br": "StreamWatchHoverCard.module__variantCompact___QjNaNU",
  "wy": "StreamWatchHoverCard.module__variantList___QjNaNU",
  "VH": "StreamWatchHoverCard.module__preview___QjNaNU",
  "sf": "StreamWatchHoverCard.module__previewCompact___QjNaNU",
  "$8": "StreamWatchHoverCard.module__previewList___QjNaNU",
  "oz": "StreamWatchHoverCard.module__previewImage___QjNaNU",
  "nZ": "StreamWatchHoverCard.module__previewFallback___QjNaNU",
  "SV": "StreamWatchHoverCard.module__compactButtonWrap___QjNaNU",
  "Iq": "StreamWatchHoverCard.module__compactButton___QjNaNU",
  "$l": "StreamWatchHoverCard.module__actionRow___QjNaNU",
  "uu": "StreamWatchHoverCard.module__actionButtons___QjNaNU",
  "jb": "StreamWatchHoverCard.module__listButton___QjNaNU",
  "fX": "StreamWatchHoverCard.module__previewClickable___QjNaNU",
  "FC": "StreamWatchHoverCard.module__previewHoverOverlay___QjNaNU",
  "Mp": "StreamWatchHoverCard.module__previewHoverText___QjNaNU",
  "z0": "StreamWatchHoverCard.module__protipRow___QjNaNU",
  "cm": "StreamWatchHoverCard.module__protipText___QjNaNU",
};

module.exports = exports;
